//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
  name: "SearchBox",
  props: [
    "searchPlaceholder",
    "searchButtonText",
    "showAlpha"
  ],
  computed: {
    ...mapGetters([
      'settings',
      'results',
      'searchQuery',
      'submittedSearchTerm',
      'selectedSort'
    ]),
    query: {
      get() {
        return this.searchQuery.searchTerm;
      },
      set(value) {
        this.setQuery(value);
      }
    },
    alphaFilter: {
      get() {
        return this.searchQuery.alphaFilter;
      },
      set(value) {
        if (value === this.searchQuery.alphaFilter) {
          value = "";
        }
        this.setAlphaFilter(value);
      }
    },
    resultSummary: function () {
      if(!this.submittedSearchTerm || this.submittedSearchTerm.length.trim == '') {
        return "";
      }
      
      return `${this.results.totalResultCount} results found for "${this.submittedSearchTerm}"`;
    }
  },
  methods: {
    ...mapMutations([
      'setQuery',
      'setAlphaFilter',
      'setOrderBy',
      'setSelectedSort']),
    submitAlphaFilter(letter) {
      this.alphaFilter = letter;
      this.$emit("submitalphafilter");
    },
    submitSearch() {
      this.$emit("submitsearch");

      // TODO - there's got to be a better way...
      // Updating top aon search box with search term.
      let topSearchBox = document.querySelector('#searchtxt');

      if(topSearchBox) {
        topSearchBox.value = this.searchQuery.searchTerm;
      }
    },
    sortByDate(order) {
      this.setOrderBy(`documentlastpublished ${order}`);
      this.setSelectedSort(order)
      this.$emit("submitsearch");
    },
    sortByRelevancy() {
      this.setOrderBy("");
      this.setSelectedSort("relevancy")
      this.$emit("submitsearch");
    },
  },
};
